module.exports = __webpack_public_path__ + "img/speedometer-03.633ac948.svg";